module.exports = __webpack_public_path__ + "static/img/avatar.f2097c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.jpg
// module id = lS+k
// module chunks = 0